import React, { useState, useEffect } from "react";
import { Button, TextField, Grid, Tooltip, IconButton } from "@mui/material";
import gststyle from "./Gst2aRepository.module.css";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import DownloadIcon from "@mui/icons-material/Download";
import { ValidatorForm } from "react-material-ui-form-validator";
import { TextValidator } from "react-material-ui-form-validator";
import axios from "../../../../axios-order";
import Switch from '@mui/material/Switch';
import DatePicker from './DatePicker'
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory } from "react-router-dom";
import moment from "moment";
import BoxWrapper from "../../../../components/ui/boxWrapper";
import ToggleSwitch from "../../../../components/ui/ToggleSwitch/ToggleSwitch";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import SettingsIcon from '@mui/icons-material/Settings';
import Modal from "react-bootstrap/Modal";
import { canWrite } from '../../../../utils/privilegeUtils';

const apiUrl = process.env.REACT_APP_BACKEND_BASE_URL;

const dateFormat = (value) => {
  if (!value) {
    return "";
  }
  const current_date = new Date(value);
  const yy = current_date.getFullYear().toString();
  const mm = (current_date.getMonth() + 1).toString();
  const dd = current_date.getDate().toString();
  return `${dd}/${mm}/${yy}`;
};

export default function Gst2aRepository() {
  const [openAndCloseModel, setOpenAndCloseModel] = useState(false);
  const [next, setNext] = useState(false)
  const history = useHistory();

  const [fileName, setFileName] = useState("");
  const [fileDataToUpload, setFileDataToUpload] = useState("");
  const [trigarCircularProgress, setTrigarCircularProgress] = useState(false);

  //...............For Error Message..........................
  const [colorForErrorMessage, setColorForErrorMessage] = useState("red");
  const [errorMessage, setErrorMessage] = useState("");
  const [errorMessageVisibilityStyle, setErrorMessageVisibilityStyle] =
    useState("hidden");
  const [errorMessageDisplayStyle, setErrorMessageDisplayStyle] =
    useState("none");

  //.........Record From Get Api.................
  const [recordFromApi, setRecordFromApi] = useState([]);
  const [recordFromApiForSearch, setRecordFromApiForSearch] = useState([]);

  const [loaderForTable, setLoaderForTable] = useState(false);
  const [loaderForFileUpload, setLoaderForFileUpload] = useState(false);

  //This is for Gst Auto Download
  const [fromMonthYearDisplay, setFromMonthYearDisplay] = useState('')
  const [fromToYearDisplay, setFromToYearDisplay] = useState('')
  const [responseMessage, setResponseMessage] = useState("");

  //Gstr Status code 
  const [status, setStatus] = useState(false);
  const [data, setData] = useState([]);
  const [errorMessages, setErrorMessages] = useState('');
  const [showBoxWrapper, setShowBoxWrapper] = useState(false);
  const [responseData, setResponseData] = useState("");
  const [displayResponse, setDisplayResponse] = useState(false);
  const [taskId, setTaskId] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  //SnackBar
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [message, setMessage] = useState('');
  const [showSuccessOnly, setShowSuccessOnly] = useState(false);
  const [toMonthError, setToMonthError] = useState("");
  const [reportStatusModalOpen, setReportStatusModalOpen] = useState(false);
  const [autoDownloadStatusData, setAutoDownloadStatusData] = useState(null);
  const [selectedRecord, setSelectedRecord] = useState(null);

  // Function to open Snackbar
  const handleSnackbarOpen = (message, severity) => {
    setSnackbarOpen(true);
    setSnackbarSeverity(severity);
    setResponseMessage(message);
  };

  // Function to close Snackbar
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
    setSnackbarSeverity("success");
    setResponseMessage("");
  };

  const handleIconClick = (msg) => {
    setMessage(msg);
    setSnackbarOpen(true);
  };

  const handleBackNavigation = () => {
    history.push("/repoCards");
  };

  const handleReportStatus = (record) => {
    console.log(record);
    setSelectedRecord(record);

    const org_gstin = localStorage.getItem("gst");

    // Fetch auto download status for GSTR2A
    axios
      .get(`/get_gstr2a_action_wise_status/${record.gstr_upload_id}/${org_gstin}`)
      .then((res) => {
        if (res?.data?.status && res?.data?.data) {
          setAutoDownloadStatusData(res.data.data);
        } else {
          setAutoDownloadStatusData(null);
        }
        setReportStatusModalOpen(true);
      })
      .catch((error) => {
        console.log('Error fetching auto download status:', error);
        setAutoDownloadStatusData(null);
        setReportStatusModalOpen(true);
      });
  };

  useEffect(() => {
    // Call the additional API only when taskId is available
    if (taskId) {
      const additionalApiUrl = `/autodownloadapi/${taskId}`;
      axios.get(additionalApiUrl)
        .then(response => {
          // Process the additional API response as needed
        })
        .catch(error => {
          console.error('Error calling additional API:', error);
        });
    }
  }, [taskId]);

  const handleButtonClick = () => {
    setShowBoxWrapper(!showBoxWrapper);
  };

  const closeReportStatusModal = () => {
    setReportStatusModalOpen(false);
  };

  const handleDownload = (gst_task_id, business_entity_id) => {
    const url = `${apiUrl}/mydemo/gstDownload/gstrtaskdownload/`;
    const requestData = new FormData();
    requestData.append('task_id', gst_task_id);
    requestData.append('entity_id', business_entity_id);

    axios.post(url, requestData)
      .then(response => {
        setResponseData(response.data)
        setDisplayResponse(true);
        const autoTaskId = extractAutoTaskId(response.data);
        if (autoTaskId) {
          setTaskId(autoTaskId);
        }

        setTimeout(() => {
          setResponseData('');
          setDisplayResponse(false);
        }, 10000);
      })
      .catch(error => {
        console.error('Error sending data:', error);
      });
  };

  const extractAutoTaskId = (response) => {
    const autoTaskIdPattern = /Auto Task id :(\d+)/;
    const match = response.match(autoTaskIdPattern);
    return match ? match[1] : null;
  };

  const business_entity_id = localStorage.getItem('business_entity_id');

  const handleChange = (event) => {
    setNext(event.target.checked);
  };

  const inputHandlerFromPicker = (v) => {
    const formattedDate = v ? moment(v).format('MMYYYY') : '';
    const usePassThrough = process.env.REACT_APP_USE_PASSTHROUGH === 'true';

    if (usePassThrough) {
    setFromMonthYearDisplay(formattedDate);
      setFromToYearDisplay('');
    setToMonthError("");
    } else {
      setFromMonthYearDisplay(formattedDate);
      setFromToYearDisplay(formattedDate);
      setToMonthError("");
    }
  };

  //Function for the Date and Month Picker
  const inputHandlerToPicker = (v) => {
    const formattedDate = v ? moment(v).format('MMYYYY') : '';
    setFromToYearDisplay(formattedDate);

    // Validate if within financial year
    if (fromMonthYearDisplay && formattedDate) {
      if (!isWithinFinancialYear(fromMonthYearDisplay, formattedDate)) {
        setToMonthError("Please select within the financial year (Apr to Mar)");
      } else {
        setToMonthError("");
      }
    }
  };

  const isWithinFinancialYear = (fromDate, toDate) => {
    if (!fromDate || !toDate) return true;

    const from = moment(fromDate, 'MMYYYY');
    const to = moment(toDate, 'MMYYYY');

    // Get financial year start (April of the year)
    const fromMonth = from.month(); // 0-11
    const fromYear = from.year();

    let fyStart, fyEnd;

    if (fromMonth >= 3) { // April (3) to March (2)
      fyStart = moment(`04${fromYear}`, 'MMYYYY');
      fyEnd = moment(`03${fromYear + 1}`, 'MMYYYY');
    } else {
      fyStart = moment(`04${fromYear - 1}`, 'MMYYYY');
      fyEnd = moment(`03${fromYear}`, 'MMYYYY');
    }

    return to.isSameOrAfter(fyStart) && to.isSameOrBefore(fyEnd);
  };

  const getToMonthDateRange = () => {
    if (!fromMonthYearDisplay) return {};

    const from = moment(fromMonthYearDisplay, 'MMYYYY');
    const fromMonth = from.month();
    const fromYear = from.year();

    let fyEnd;
    if (fromMonth >= 3) {
      fyEnd = moment(`03${fromYear + 1}`, 'MMYYYY');
    } else {
      fyEnd = moment(`03${fromYear}`, 'MMYYYY');
    }

    return {
      minDate: from.toDate(),
      maxDate: fyEnd.clone().endOf('month').toDate()
    };
  };

  const shouldDisableDate = (date) => {
    if (!fromMonthYearDisplay) return false;

    const from = moment(fromMonthYearDisplay, 'MMYYYY');
    const fromMonth = from.month(); // 0-11
    const fromYear = from.year();

    let fyStart, fyEnd;

    if (fromMonth >= 3) { // April (3) to March (2)
      fyStart = moment(`04${fromYear}`, 'MMYYYY');
      fyEnd = moment(`03${fromYear + 1}`, 'MMYYYY');
    } else {
      fyStart = moment(`04${fromYear - 1}`, 'MMYYYY');
      fyEnd = moment(`03${fromYear}`, 'MMYYYY');
    }

    const checkDate = moment(date);

    // Date must be within financial year AND greater than or equal to from date
    const isWithinFY = checkDate.isBetween(fyStart, fyEnd, 'month', '[]');
    const isAfterOrEqualFrom = checkDate.isSameOrAfter(from, 'month');

    return !(isWithinFY && isAfterOrEqualFrom);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setResponseMessage("");
    }, 7000);
    return () => clearTimeout(timer);
  }, [responseMessage]);

  const handleGSTR2ADownload = async () => {
    setIsSubmitting(true);

    const usePassThrough = process.env.REACT_APP_USE_PASSTHROUGH === 'true';
    const entity_id = localStorage.getItem('business_entity_id');
    const gstin = localStorage.getItem('gst');

    if (usePassThrough) {
      axios
        .post(`/get_gstr2a_autodownload_pass_through_response_data`, {
      entity_id: entity_id,
      gstin: gstin,
      fromRetPeriod: fromMonthYearDisplay,
      toRetPeriod: fromToYearDisplay
    })
      .then(response => {
          const responseData = response.data;
          if (responseData.status === false && responseData.message) {
            handleSnackbarOpen(responseData.message, 'error');
          } else if (responseData.status === "success" && responseData.message) {
            handleSnackbarOpen(responseData.message, 'success');
          } else if (responseData.message_type && responseData.message) {
            handleSnackbarOpen(responseData.message, responseData.message_type);
          } else {
            handleSnackbarOpen('An unexpected response was received.', 'error');
          }
      })
      .catch(error => {
        console.log(error);
        handleSnackbarOpen('Unexpected Error.', 'error');
      })
      .finally(() => {
        setIsSubmitting(false);
      });

    } else {
      const formData = new FormData();
      formData.append('entity_id', entity_id);
      formData.append('fromRetPeriod', fromMonthYearDisplay);
      formData.append('toRetPeriod', fromToYearDisplay);

      try {
        const response = await axios.post(`${apiUrl}/mydemo/gstDownload/gstr2adownload/`, formData);
        const responseData = response.data;
        if (responseData.message_type && responseData.message) {
          handleSnackbarOpen(responseData.message, responseData.message_type);
        } else {
          handleSnackbarOpen('An unexpected response was received.', 'error');
        }
      } catch (error) {
        console.log(error);
        handleSnackbarOpen('Unexpected Error.', 'error');
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  //...........Open And Close Event For Model............
  const handleOpenAndClose = () => {
    setOpenAndCloseModel(!openAndCloseModel);
    setTrigarCircularProgress(false);
    setColorForErrorMessage("red");
    setErrorMessage("");
    setErrorMessageVisibilityStyle("hidden");
    setErrorMessageDisplayStyle("none");
    setFileDataToUpload("");
    setFileName("");
    setLoaderForFileUpload(false);
  };

  const fileUploadCancelButtonHandler = () => {
    setTrigarCircularProgress(false);
    setColorForErrorMessage("red");
    setErrorMessage("");
    setErrorMessageVisibilityStyle("hidden");
    setErrorMessageDisplayStyle("none");
    setFileDataToUpload("");
    setFileName("");
    setLoaderForFileUpload(false);
  };

  //......Handle Search....................
  const handleSearch = (e) => {
    let Search = e.target.value;
    const searchName = recordFromApiForSearch.filter((v) => {
      return (
        String(v.gstr_upload_file_type)
          .toLowerCase()
          .indexOf(Search.toLowerCase()) >= 0 ||
        String(v.financial_year).toLowerCase().indexOf(Search.toLowerCase()) >=
        0 ||
        String(v.generation_date).toLowerCase().indexOf(Search.toLowerCase()) >=
        0 ||
        String(v.upload_date).toLowerCase().indexOf(Search.toLowerCase()) >=
        0 ||
        String(moment(v.tax_period, "MMYYYY").format("MMMM-YYYY"))
          .toLowerCase()
          .indexOf(Search.toLowerCase()) >= 0
      );
    });
    setRecordFromApi(searchName);
  };

  //........For Succesfull Message..................
  const functionForSuccesfullMessage = () => {
    setColorForErrorMessage("green");
    setErrorMessageVisibilityStyle("visible");
    setErrorMessageDisplayStyle("block");
  };

  //............File Upload Data Saving in useState................
  const handleFileUpload = (e) => {
    setErrorMessageVisibilityStyle("hidden");
    setErrorMessageDisplayStyle("none");
    setErrorMessage("");
    if (e.target.files.length) {
      const file_data = e.target.files[0];
      let fileName = file_data.name;
      setFileName(fileName);
      const reader = new FileReader();
      reader.readAsDataURL(file_data);
      reader.onload = function () {
        let file_value = reader.result;
        setFileDataToUpload(file_value);
      };
      e.target.value = null;
    }
  };

  //....................Submit Event For File Upload in axios...............
  const handleSubmitEvent = (e) => {
    if (fileDataToUpload === "") {
      setErrorMessageVisibilityStyle("visible");
      setErrorMessageDisplayStyle("block");
      setErrorMessage("Please Upload The File!");
      setLoaderForFileUpload(false);
      window.setTimeout(() => {
        setErrorMessageVisibilityStyle("visible")
      }, 2000)
    } else {
      setTrigarCircularProgress(true);
      setLoaderForFileUpload(true);
      axios
        .post(`/gst2a_recon_upload`, {
          file: fileDataToUpload,
          gstin: localStorage.getItem("gst"),
        })
        .then((res) => {
          if (res.data.status === false) {
            setTrigarCircularProgress(false);
            setErrorMessageVisibilityStyle("visible");
            setErrorMessageDisplayStyle("block");
            setErrorMessage(res.data.message);
            setLoaderForFileUpload(false);
          }
          if (res.data.status === true) {
            setTrigarCircularProgress(false);
            setErrorMessage(res.data.message);
            functionForSuccesfullMessage();
            getApiForGst2aRepository();
            setLoaderForFileUpload(false);
            resetFileUpload();
          }
        })
        .catch((error) => {
          setErrorMessageVisibilityStyle("visible");
          setErrorMessageDisplayStyle("block");
          setErrorMessage(error.response.data.message);
          setLoaderForFileUpload(false);
          resetFileUpload();
        });
    }
  };

  const resetFileUpload = () => {
    setFileDataToUpload(null);
    setFileName("");
  };

  //.......................Get Api For Gst................
  const getApiForGst2aRepository = () => {
    setLoaderForTable(true);
    axios
      .post(`/get_gst2a_repo`, { gst: localStorage.getItem("gst") })
      .then((res) => {
        if (res.data.status === false) {
          setLoaderForTable(false);
        } else {
          setLoaderForTable(false);
          setRecordFromApi(res.data.record);
          setRecordFromApiForSearch(res.data.record);
        }
      })
      .catch((error) => {
        setLoaderForTable(false);
        setErrorMessage("Error Fetching Data")
      });
  };

  const newReconModalClose = () => {
    setFileName("");
    setFromMonthYearDisplay("");
    setFromToYearDisplay("");
    setFileDataToUpload("");
    setErrorMessage("");
  };

  const dateFormat = (value) => {
    if (!value) return "";

    const m = moment(value, [
      "YYYY-MM-DD",
      "DD-MM-YYYY",
      "DD/MM/YYYY"
    ], true);

    return m.isValid() ? m.format("DD/MM/YYYY") : "";
  };


  useEffect(() => {
    getApiForGst2aRepository();
  }, []);

  return (
    <React.Fragment>
      <div style={{ padding: "15px 20px", backgroundColor: "#f5f5f5" }}>
        <Tooltip title="Back" arrow>
          <IconButton
            onClick={handleBackNavigation}
            sx={{
              borderRadius: '50%',
              padding: '6px',
              color: '#263238',
              fontSize: '20px',
              backgroundColor: '#ffffff',
              height: '36px',
              width: '36px',
              '&:hover': {
                backgroundColor: '#455a64',
                color: '#ffffff',
              },
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
              transition: 'background-color 0.3s ease',
            }}
          >
            <ArrowBackIcon sx={{ fontSize: '20px' }} />
          </IconButton>
        </Tooltip>
      </div>
      {canWrite("GSTR2") && (
      <BoxWrapper
        boxTitle={
          <div style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            width: "100%",
            paddingRight: "20px",
            position: "relative"
          }}>
            <span style={{ fontWeight: 600, color: "#000" }}>
              GSTR-2A Repository
            </span>
            <span style={{ fontWeight: 600, position: "absolute", left: "45%", transform: "translateX(-50%)" }}>
              GSTR-2A Auto Download
            </span>
          </div>
        }
      >
        <ValidatorForm
          onSubmit={(e) => {
            e.preventDefault();
            if (fileName && fileDataToUpload) {
              handleSubmitEvent(e);
            } else if (fromMonthYearDisplay && fromToYearDisplay) {
              handleGSTR2ADownload();
            }
          }}
          onError={(errors) => console.log(errors)}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <div style={{ display: 'flex', alignItems: 'flex-end', gap: '40px' }}>
              {/* Upload Button */}
              <div style={{ minWidth: '100px' }}>
                <label
                  className="button-primary"
                  style={{
                    width: "100%",
                    textAlign: "center",
                    cursor: fromMonthYearDisplay ? "not-allowed" : "pointer",
                    padding: "8px",
                    display: 'block',
                    opacity: fromMonthYearDisplay ? 0.5 : 1,
                    pointerEvents: fromMonthYearDisplay ? 'none' : 'auto'
                  }}
                >
                  Upload
                  <input
                    type="file"
                    accept=".xlsx,.json,.zip"
                    onChange={handleFileUpload}
                    hidden
                    disabled={!!fromMonthYearDisplay}
                  />
                </label>
              </div>

              {/* File name field */}
              <div style={{ flex: '0 0 350px' }}>
                <TextField
                  placeholder="Choose file"
                  value={fileName}
                  variant="standard"
                  fullWidth
                  disabled={!!fromMonthYearDisplay}
                  style={{ opacity: fromMonthYearDisplay ? 0.5 : 1 }}
                  inputProps={{
                    readOnly: true,
                  }}
                />
              </div>

              {/* From Date Picker */}
              <div style={{ flex: '0 0 300px', opacity: fileName ? 0.5 : 1 }}>
                <label style={{ color: 'black', display: 'block', marginBottom: '4px', fontSize: '14px' }}>
                  Please Select From Month and Year <span style={{ color: 'red' }}>*</span>:
                </label>
                <DatePicker
                  views={['year', 'month']}
                  placeholder="From Year to Month"
                  format="MM/yyyy"
                  value={fromMonthYearDisplay}
                  onChange={inputHandlerFromPicker}
                  disabled={!!fileName}
                />
              </div>

              {/* To Date Picker */}
              <div style={{ flex: '0 0 300px', opacity: fileName ? 0.5 : 1 }}>
                <label style={{ color: 'black', display: 'block', marginBottom: '4px', fontSize: '14px' }}>
                  Please Select To Month and Year <span style={{ color: 'red' }}>*</span>:
                </label>
                <DatePicker
                  views={['year', 'month']}
                  value={fromToYearDisplay}
                  format="MM/yyyy"
                  picker="month"
                  onChange={inputHandlerToPicker}
                  minDate={getToMonthDateRange().minDate}
                  maxDate={getToMonthDateRange().maxDate}
                  placeholder="Select To Month and Year"
                  disabled={
                    !fromMonthYearDisplay ||
                    !!fileName ||
                    process.env.REACT_APP_USE_PASSTHROUGH !== 'true' 
                  }
                />
                {toMonthError && (
                  <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                    {toMonthError}
                  </div>
                )}
              </div>

              {/* Button Group */}
              <div style={{ display: 'flex', gap: '5px', marginLeft: '-25px' }}>
                <div style={{ minWidth: '100px' }}>
                  <button
                    className="button-primary"
                    type="submit"
                    style={{ width: '100%', padding: '8px' }}
                    disabled={isSubmitting || !!toMonthError}
                  >
                    {isSubmitting ? 'Submitting...' : 'Submit'}
                  </button>
                </div>

                <div style={{ minWidth: '100px' }}>
                  <button
                    type="button"
                    className="button-outlined-secondary"
                    onClick={newReconModalClose}
                    style={{ width: '100%', padding: '8px' }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ValidatorForm>
        {errorMessage && (
          <p style={{ color: "red", marginTop: "10px" }}>{errorMessage}</p>
        )}
      </BoxWrapper>
      )}

      {/*..................Table.......................*/}
      <BoxWrapper
        boxTitle="History"
        // search input
        enableSearchInput={true}
        searchInputPlaceholder="Search..."
        searchInputOnchange={handleSearch}

        enableAddButton={true}
        addButtonLabel="Refresh"
        addButtonHandlerFn={getApiForGst2aRepository}
      >
        <div className="responsive-table">
          <table className="custome-table">
            <thead>
              <tr>
                <th>GSTR2A UPLOAD FILE TYPE</th>
                <th>TAX PERIOD</th>
                <th>FINANCIAL YEAR</th>
                <th>GENERATION DATE</th>
                <th>UPLOAD DATE</th>
                <th>STATUS</th>
                <th>
                  <label>
                    <input
                      type="checkbox"
                      checked={showSuccessOnly}
                      onChange={() => setShowSuccessOnly(!showSuccessOnly)}
                    />
                    Show Pass Only
                  </label>
                </th>
                {/* <th>Action</th> */}
              </tr>
            </thead>
            <tbody>
              {recordFromApi?.filter((v) => !showSuccessOnly || v.upload_status === "Pass")
                .map((v, index) => {
                  const formattedTaxPeriod =
                    v.tax_period && moment(v.tax_period, "MMYYYY").isValid()
                      ? moment(v.tax_period, "MMYYYY").format("MMMM-YYYY")
                      : "";
                  return (
                    <tr key={index}>
                      <td style={{ textTransform: "capitalize" }}>{v.gstr_upload_file_type}</td>
                       <td style={{ textTransform: "capitalize" }}>{formattedTaxPeriod}</td>
                      {/* <td style={{ textTransform: "capitalize" }}>
                        {v.tax_period !== "None" && v.tax_period ? (
                          v.tax_period.includes(',') ? (
                            // Multiple tax periods separated by comma
                            v.tax_period.split(',').map((period, idx) => (
                              <span key={idx}>
                                {moment(period.trim(), "MMYYYY").format("MMMM YYYY")}
                                {idx < v.tax_period.split(',').length - 1 && ', '}
                              </span>
                            ))
                          ) : v.tax_period.includes('-') ? (
                            // Date range format (e.g., "012026 - 032026")
                            (() => {
                              const [start, end] = v.tax_period.split('-').map(p => p.trim());
                              return `${moment(start, "MMYYYY").format("MMMM YYYY")} - ${moment(end, "MMYYYY").format("MMMM YYYY")}`;
                            })()
                          ) : (
                            // Single tax period
                            moment(v.tax_period, "MMYYYY").format("MMMM YYYY")
                          )
                        ) : (
                          ""
                        )}
                      </td> */}
                      <td>{v.financial_year !== "None" ? v.financial_year : ""}</td>
                      <td style={{ textTransform: "capitalize" }}>
                        {v.generation_date ? dateFormat(v.generation_date) : ""}
                      </td>
                      <td style={{ textTransform: "capitalize" }}>
                        {v.upload_date ? dateFormat(v.upload_date) : ""}
                      </td>
                      <td>{v.upload_status}</td>
                      <td>
                        {v.upload_status === 'Fail' ? (
                          <div>
                            <VisibilityOutlinedIcon
                              className="action-icon-button showIcon failIcon"
                              style={{ color: 'red' }}
                              onClick={() => handleIconClick(v.upload_fail_reason)}
                            />
                          </div>
                        ) : (
                          <div>
                            <VisibilityOutlinedIcon
                              className="action-icon-button showIcon"
                              onClick={() => handleIconClick('Data Uploaded')}
                            />
                          </div>
                        )}
                      </td>
                      {/* <td>
                        <SettingsIcon
                          className="action-icon-button showIcon"
                          onClick={v.gstr_upload_file_ext === "Auto Download" ? () => handleReportStatus(v) : null}
                          style={{
                            cursor: v.gstr_upload_file_ext === "Auto Download" ? 'pointer' : 'not-allowed',
                            color: v.gstr_upload_file_ext === "Auto Download" ? '#2938c2' : '#d3d3d3',
                            opacity: v.gstr_upload_file_ext === "Auto Download" ? 1 : 0.5
                          }}
                        />
                      </td> */}
                    </tr>
                  );
                })}
              {loaderForTable ? (
                <tr>
                  <td
                    colSpan={7}
                    style={{
                      color: "black",
                      textAlign: "center",
                      fontWeight: "bold",
                    }}
                  >
                    Loading…Please wait
                  </td>
                </tr>
              ) : recordFromApi?.length === 0 ? (
                <tr>
                  <td colSpan={7} style={{ color: "red", textAlign: "center" }}>
                    No Data Found!
                  </td>
                </tr>
              ) : (
                ""
              )}
            </tbody>
          </table>
        </div>
      </BoxWrapper>

      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={handleSnackbarClose}
        style={{ maxWidth: '25%' }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
        >
          {responseMessage}
          {message}
        </MuiAlert>
      </Snackbar>

      {responseData && (
        <div>
          <p style={{ fontSize: '20px', color: 'green' }}>DOWNLOADED GSTR DATA</p>
          <p>{responseData}</p>
        </div>
      )}
      {/* <Modal
        size="lg"
        aria-labelledby="report-status-modal-title"
        centered
        show={reportStatusModalOpen}
        onHide={closeReportStatusModal}
        dialogClassName="modal-lg"
      >
        <Modal.Header closeButton className="modal-header">
          <Modal.Title id="report-status-modal-title">
            Auto Download Status Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="responsive-table">
            <table className="custome-table">
              <thead>
                <tr>
                  <th>Period</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {autoDownloadStatusData?.action_wise_status?.length > 0 ? (
                  autoDownloadStatusData.action_wise_status.map((item, index) => (
                    <tr key={index}>
                      <td>
                        {item.period ? moment(item.period, "MMYYYY").format("MMMM-YYYY") : "-"}
                      </td>
                      <td>{item.status || "-"}</td>
                      <td>
                        <div
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            const message = item.message || `Status: ${item.status}`;
                            const severity = item.status === "PASS" ? "success" : "error";
                            handleSnackbarOpen(message, severity);
                          }}
                        >
                          <VisibilityOutlinedIcon
                            className="action-icon-button showIcon"
                            style={{ color: item.status === "PASS" ? "#2938c2" : "#f44336" }}
                          />
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={3} style={{ textAlign: "center" }}>
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="button-outlined-secondary"
            onClick={closeReportStatusModal}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal> */}

    </React.Fragment>
  );
}